import React, { useState, useEffect } from 'react';
import nesrLogo from '../assets/nesr-logo.png'; // لوجو الشركة (نفس لوجو موقع nisrelkhaleeg.com)
import { useDarkTheme } from '../theme';
import { BookOpen, Plus, Edit2, Trash2 } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { 
  FileText, 
  Users, 
  CreditCard, 
  Database,
  LogOut,
  Building2,
  User,
  Briefcase,
  Building,
  DollarSign,
  AlertCircle,
  FileSpreadsheet,
  MessageSquare,
  PieChart, 
  Globe, 
  FileCheck, 
  Stamp,
  UserCheck,
  CheckCircle,
  Clock,
  Archive,
  Plane,
  BarChart3,
  Upload,
  Wallet,
  Moon,
  Sun,
  ChevronLeft,
  Save,
  Menu,
  X,
  Bosh2,
  Settings,
  Search,
  ListTodo
} from 'lucide-react';

const Dashboard = ({ onLogout }) => {
  const [userPermissions, setUserPermissions] = useState({});
  const [fullName, setFullName] = useState('');
  const [isDark, setDark] = useDarkTheme(); // وضع النهار/الليل للسيستم كله (src/theme.js)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showNotificationManager, setShowNotificationManager] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [currentNotification, setCurrentNotification] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [newNotification, setNewNotification] = useState({ text: '', type: 'hadith' });
  const [mobileSearch, setMobileSearch] = useState('');
  const [openMobileSection, setOpenMobileSection] = useState(null);
  const navigate = useNavigate();

    // ✅ هوية الشركة (زي موقع nisrelkhaleeg.com)
  const BRAND = {
    arabicName: 'نسر الخليج',
    englishName: 'لإلحاق العمالة المصرية بالخارج',
    systemName: 'شركة نسر الخليج',
    systemEnglishName: 'TRAVEL & PASSPORT MANAGEMENT',
    bannerCaption: 'رحلة آمنة • إدارة ذكية',
    footerText: `© ${new Date().getFullYear()} نسر الخليج لإلحاق العمالة المصرية بالخارج · ترخيص وزارة القوى العاملة رقم 863 · تطوير مسار للأنظمة الذكية`,
  };

   // 🔹 قوائم النصوص الإسلامية المحسّنة
  const HADITHS = [
    'قال رسول الله ﷺ: "من قال سبحان الله وبحمده في يوم مائة مرة حُطَّت خطاياه وإن كانت مثل زبد البحر" — متفق عليه',
    'قال رسول الله ﷺ: "الكلمة الطيبة صدقة" — متفق عليه',
    'قال رسول الله ﷺ: "إنما الأعمال بالنيات، وإنما لكل امرئ ما نوى" — متفق عليه',
    'قال رسول الله ﷺ: "أحب الأعمال إلى الله أدومها وإن قلّ" — متفق عليه',
    'قال رسول الله ﷺ: "من حسن إسلام المرء تركه ما لا يعنيه" — رواه الترمذي',
    'قال رسول الله ﷺ: "لا يؤمن أحدكم حتى يحب لأخيه ما يحب لنفسه" — متفق عليه',
    'قال رسول الله ﷺ: "المسلم من سلم المسلمون من لسانه ويده" — متفق عليه',
    'قال رسول الله ﷺ: "من كان يؤمن بالله واليوم الآخر فليقل خيرًا أو ليصمت" — متفق عليه',
    'قال رسول الله ﷺ: "اتق الله حيثما كنت، وأتبع السيئة الحسنة تمحها، وخالق الناس بخلق حسن" — رواه الترمذي',
    'قال رسول الله ﷺ: "إن الله لا ينظر إلى صوركم وأموالكم، ولكن ينظر إلى قلوبكم وأعمالكم" — رواه مسلم',
    'قال رسول الله ﷺ: "الراحمون يرحمهم الرحمن، ارحموا من في الأرض يرحمكم من في السماء" — رواه الترمذي',
    'قال رسول الله ﷺ: "أقرب ما يكون العبد من ربه وهو ساجد، فأكثروا الدعاء" — رواه مسلم',
    'قال رسول الله ﷺ: "من سلك طريقًا يلتمس فيه علمًا سهّل الله له طريقًا إلى الجنة" — رواه مسلم',
    'قال رسول الله ﷺ: "والله في عون العبد ما كان العبد في عون أخيه" — رواه مسلم',
    'قال رسول الله ﷺ: "أحبُّ الناس إلى الله أنفعهم للناس" — رواه الطبراني',
    'قال رسول الله ﷺ: "إن الله يحب إذا عمل أحدكم عملًا أن يتقنه" — رواه البيهقي',
    'قال رسول الله ﷺ: "إنما بُعثت لأُتمِّم مكارم الأخلاق" — رواه البخاري في الأدب المفرد',
    'قال رسول الله ﷺ: "اغتنم خمسًا قبل خمس: شبابك قبل هرمك، وصحتك قبل سقمك، وغناك قبل فقرك، وفراغك قبل شغلك، وحياتك قبل موتك" — رواه الحاكم',
    'قال رسول الله ﷺ: "ركعتا الفجر خيرٌ من الدنيا وما فيها" — رواه مسلم',
    'قال رسول الله ﷺ: "من كان في حاجة أخيه كان الله في حاجته" — متفق عليه',
    'قال رسول الله ﷺ: "من نفّس عن مؤمن كربةً من كرب الدنيا نفّس الله عنه كربةً من كرب يوم القيامة" — رواه مسلم',
    'قال رسول الله ﷺ: "تبسّمك في وجه أخيك صدقة" — رواه الترمذي',
    'قال رسول الله ﷺ: "ازهد في الدنيا يحبك الله، وازهد فيما عند الناس يحبك الناس" — رواه ابن ماجه',
    'قال رسول الله ﷺ: "من يرد الله به خيرًا يُفقِّهه في الدين" — متفق عليه',
    'قال رسول الله ﷺ: "الطهور شطر الإيمان، والحمد لله تملأ الميزان، وسبحان الله والحمد لله تملآن ما بين السماء والأرض" — رواه مسلم',
    'قال رسول الله ﷺ: "الدال على الخير كفاعله" — رواه الترمذي',
    'قال رسول الله ﷺ: "المؤمن للمؤمن كالبنيان يشدّ بعضه بعضًا" — متفق عليه',
    'قال رسول الله ﷺ: "إن الله كتب الإحسان على كل شيء" — رواه مسلم',
    'قال رسول الله ﷺ: "الصيام جُنّة، فلا يرفث ولا يجهل" — متفق عليه',
    'قال رسول الله ﷺ: "من قرأ آية الكرسي دبر كل صلاة مكتوبة لم يمنعه من دخول الجنة إلا أن يموت" — رواه النسائي',
    'قال رسول الله ﷺ: "ما نقصت صدقة من مال، وما زاد الله عبدًا بعفو إلا عزًّا، وما تواضع أحد لله إلا رفعه الله" — رواه مسلم',
    'قال رسول الله ﷺ: "اليد العليا خيرٌ من اليد السفلى" — متفق عليه',
    'قال رسول الله ﷺ: "حُجبت النار بالشهوات، وحُجبت الجنة بالمكاره" — متفق عليه',
    'قال رسول الله ﷺ: "كلكم راعٍ وكلكم مسؤول عن رعيته" — متفق عليه',
    'قال رسول الله ﷺ: "أفشوا السلام بينكم" — رواه مسلم',
    'قال رسول الله ﷺ: "من كان يؤمن بالله واليوم الآخر فليصل رحمه" — متفق عليه',
    'قال رسول الله ﷺ: "خير الناس أنفعهم للناس" — رواه الطبراني',
    'قال رسول الله ﷺ: "المؤمن مرآة أخيه المؤمن" — رواه أبو داود',
    'قال رسول الله ﷺ: "البر حسن الخلق" — رواه مسلم',
    'قال رسول الله ﷺ: "لا ضرر ولا ضرار" — رواه ابن ماجه',
    'قال رسول الله ﷺ: "إن من أحسن الناس إسلامًا من سلم المسلمون من لسانه ويده" — متفق عليه',
    'قال رسول الله ﷺ: "الحياء لا يأتي إلا بخير" — متفق عليه',
    'قال رسول الله ﷺ: "الصدقة تُطفئ الخطيئة كما يُطفئ الماء النار" — رواه الترمذي',
    'قال رسول الله ﷺ: "إن الله رفيق يحب الرفق في الأمر كله" — متفق عليه',
    'قال رسول الله ﷺ: "من صمت نجا" — رواه الترمذي',
  ];

  const ADHKAR = [
    // — تسبيح وتحميد —
    'سبحان الله وبحمده، سبحان الله العظيم ✨ — أحب الكلام إلى الله',
    'سبحان الله، والحمد لله، ولا إله إلا الله، والله أكبر — أحب الكلام إلى الله',
    'لا إله إلا الله وحده لا شريك له، له الملك وله الحمد وهو على كل شيء قدير',
    'لا حول ولا قوة إلا بالله العلي العظيم — كنزٌ من كنوز الجنة',
    'سبحان الله وبحمده عدد خلقه، ورضا نفسه، وزِنة عرشه، ومداد كلماته',
    'الحمد لله حمدًا كثيرًا طيبًا مباركًا فيه',
    'الحمد لله الذي بنعمته تتم الصالحات',
    'سبحان الله وبحمده — من قالها مئة مرة في اليوم حُطّت خطاياه وإن كانت مثل زبد البحر',
    'الله أكبر كبيرًا، والحمد لله كثيرًا، وسبحان الله بكرةً وأصيلًا',
    // — استغفار —
    'أستغفر الله العظيم الذي لا إله إلا هو الحي القيوم وأتوب إليه 🤲',
    'أستغفر الله وأتوب إليه — قلها سبعين مرة لتُفتح لك أبواب الرحمة',
    'أستغفر الله العظيم عدد خلقه ورضا نفسه وزنة عرشه ومداد كلماته',
    'أستغفر الله ربي من كل ذنب وأتوب إليه',
    'أستغفر الله الذي لا إله إلا هو الحي القيوم وأسأله التوبة والمغفرة',
    'اللهم إنك عفو كريم تحب العفو فاعفُ عني — استغفار ليلة القدر',
    'اللهم اغفر لي ذنبي كله، دِقَّه وجِلَّه، وأوله وآخره، وعلانيته وسره',
    'ربِّ اغفر لي وتب عليّ إنك أنت التواب الرحيم',
    'اللهم إني ظلمت نفسي ظلمًا كثيرًا، ولا يغفر الذنوب إلا أنت، فاغفر لي مغفرةً من عندك وارحمني',
    'سبحانك اللهم وبحمدك، أشهد أن لا إله إلا أنت، أستغفرك وأتوب إليك',
    'لا إله إلا أنت سبحانك إني كنت من الظالمين — دعاء يونس عليه السلام',
    'اللهم اغفر لي ولوالديّ وللمؤمنين والمؤمنات',
    'رب اغفر وارحم وأنت خير الراحمين',
    'اللهم باعد بيني وبين خطاياي كما باعدت بين المشرق والمغرب',
    'اللهم اغفر لي ما قدّمت وما أخّرت وما أسررت وما أعلنت وما أسرفت وما أنت أعلم به مني',
    // — أدعية القرآن —
    '﴿رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ﴾',
    '﴿رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً﴾',
    '﴿رَبِّ اشْرَحْ لِي صَدْرِي وَيَسِّرْ لِي أَمْرِي وَاحْلُلْ عُقْدَةً مِّن لِّسَانِي يَفْقَهُوا قَوْلِي﴾',
    '﴿رَبَّنَا اغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِي أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وَانصُرْنَا﴾',
    '﴿رَبِّ إِنِّي لِمَا أَنزَلْتَ إِلَيَّ مِنْ خَيْرٍ فَقِيرٌ﴾ — دعاء موسى عليه السلام',
    '﴿حَسْبُنَا اللَّهُ وَنِعْمَ الْوَكِيلُ﴾ — قالها إبراهيم في النار وقالها محمد ﷺ يوم أُحد',
    '﴿رَبِّ زِدْنِي عِلْمًا﴾',
    '﴿رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا﴾',
    '﴿وَلَا تَيْأَسُوا مِن رَّوْحِ اللَّهِ إِنَّهُ لَا يَيْأَسُ مِن رَّوْحِ اللَّهِ إِلَّا الْقَوْمُ الْكَافِرُونَ﴾',
    // — أدعية مأثورة —
    'اللهم إني أسألك العفو والعافية في الدنيا والآخرة',
    'اللهم إني أسألك علمًا نافعًا ورزقًا طيبًا وعملًا متقبلًا',
    'اللهم اهدني وسددني',
    'اللهم ثبّت قلبي على دينك',
    'اللهم إني أعوذ بك من الهم والحزن، والعجز والكسل، والبخل والجبن، وضلع الدين وغلبة الرجال',
    'اللهم إني أعوذ بك من علم لا ينفع، ومن قلب لا يخشع، ومن نفس لا تشبع، ومن دعاء لا يُسمع',
    'اللهم أصلح لي ديني الذي هو عصمة أمري، وأصلح لي دنياي التي فيها معاشي',
    'اللهم ارزقني حسن الخاتمة',
    'اللهم إني أسألك رضاك والجنة، وأعوذ بك من سخطك والنار',
    'اللهم اجعل القرآن ربيع قلبي، ونور صدري، وجلاء حزني وهمي',
    'اللهم يسّر ولا تعسّر، وبشّر ولا تنفّر',
    'حسبي الله لا إله إلا هو عليه توكلت وهو رب العرش العظيم — من قالها سبعًا كفاه الله همّه',
    'اللهم لك الحمد حتى ترضى، ولك الحمد إذا رضيت، ولك الحمد بعد الرضا',
    'اللهم إني أسألك قلبًا يخشاك وعينًا تدمع من خشيتك وعملًا يُرضيك',
    'اللهم إنك عفوٌّ تحب العفو فاعفُ عنا',
    'اللهم اجبر كسرنا واستر عيوبنا وآمن روعاتنا واقضِ ديوننا',
  ];

  const SALAWAT = [
    'اللهم صلِّ على محمد وعلى آل محمد كما صليت على إبراهيم وعلى آل إبراهيم إنك حميد مجيد، وبارك على محمد وعلى آل محمد كما باركت على إبراهيم وعلى آل إبراهيم إنك حميد مجيد 💚',
    'اللهم صلِّ وسلم وبارك على سيدنا محمد ﷺ',
    'اللهم صلِّ على سيدنا محمد عدد ما ذكره الذاكرون، وعدد ما غفل عن ذكره الغافلون',
    'اللهم صلِّ وسلم على سيدنا محمد عدد خلقك، ورضا نفسك، وزنة عرشك، ومداد كلماتك',
    'اللهم صلِّ وسلم على سيدنا محمد صلاةً تنجينا بها من جميع الأهوال والآفات، وتقضي لنا بها جميع الحاجات',
    'اللهم صلِّ على سيدنا محمد وعلى آله وصحبه أجمعين، وسلّم تسليمًا كثيرًا',
    'اللهم صلِّ على سيدنا محمد صلاةً دائمة متصلة باقية إلى يوم الدين',
    'اللهم صلِّ وسلم على سيدنا محمد في الأولين والآخرين والملأ الأعلى إلى يوم الدين',
    'اللهم صلِّ على سيدنا محمد صلاةً تملأ بها الأكوان نورًا، وتغشانا بها رحمةً وسرورًا',
    'صلى الله عليك يا رسول الله ﷺ — من صلى عليّ مرةً صلى الله عليه عشرًا',
    'اللهم صلِّ على محمد النبي الأمي وعلى آله وصحبه وسلّم',
    'اللهم صلِّ وسلم على شفيع الأمة ومُبلِّغ الرسالة سيدنا محمد ﷺ',
    'اللهم صلِّ على سيدنا محمد وعلى آل محمد أفضل صلاة وأزكى سلام',
    'اللهم صلِّ على سيدنا محمد ما تعاقب الليل والنهار، وما أضاء النهار وأظلم الليل',
    'اللهم صلِّ وسلم على سيدنا محمد وعلى آله عدد ما في السموات وما في الأرض وما بينهما',
    'اللهم صلِّ على سيدنا محمد صلاةً تفتح بها لنا الأبواب المغلقة، وتيسّر بها الأمور العسيرة',
    'اللهم صلِّ على سيدنا محمد صلاةً ترفع بها درجاتنا وتكفّر بها سيئاتنا',
    'اللهم صلِّ وسلم على الحبيب المصطفى والنبي المجتبى سيدنا محمد ﷺ',
    'اللهم صلِّ على سيدنا محمد وعلى آله وصحبه ومن تبعهم بإحسان إلى يوم الدين',
    'اللهم صلِّ على سيدنا محمد عدد قطر الأمطار وعدد أوراق الأشجار وعدد أمواج البحار',
    'اللهم صلِّ وسلم وبارك على نبينا محمد — سبب لقضاء الحوائج وتفريج الكربات',
    'اللهم صلِّ على سيدنا محمد صلاةً تكون لنا نورًا في الدنيا وزادًا للآخرة',
    'اللهم صلِّ على سيدنا محمد وأدخله المقام المحمود الذي وعدته',
    'اللهم صلِّ على سيدنا محمد وارزقنا شفاعته يوم لا ينفع مال ولا بنون',
    'اللهم آتِ سيدنا محمدًا الوسيلة والفضيلة، وابعثه المقام المحمود الذي وعدته',
    'اللهم صلِّ على سيدنا محمد كما أمرتنا بالصلاة عليه صلاةً لا نهاية لها ولا انقطاع',
    'اللهم صلِّ على سيدنا محمد وعلى آله الطيبين الطاهرين',
    'اللهم صلِّ وسلم على سيدنا محمد صلاة تسدّ بها خلّتنا وتجبر بها كسرنا',
    'اللهم اجعل درود قلبي على نبيك ﷺ دائمًا لا ينقطع',
    'اللهم صلِّ على سيدنا محمد وارزقنا محبته واتباع سنته ﷺ',
    'اللهم صلِّ على سيدنا محمد عدد نَفَسِ كل مخلوق وعدد قطرات المطر وعدد الرمال',
    'اللهم صلِّ على سيدنا محمد وبلّغه الوسيلة والفضيلة والدرجة الرفيعة',
    'اللهم صلِّ على سيدنا محمد وعلى آله كما تحب أنت وترضى',
  ];

  const REMINDERS = [
    '⏰ الصلاة عماد الدين — لا تؤجّل صلاتك فإنها أول ما تُسأل عنه يوم القيامة',
    '📖 اقرأ ولو صفحةً من القرآن الكريم الآن — فكل حرف بعشر حسنات',
    '🤲 أكثر من الاستغفار الآن — قال ﷺ: "من لزم الاستغفار جعل الله له من كل ضيق مخرجًا ومن كل هم فرجًا"',
    '💚 قل "الحمد لله" الآن — فهي تملأ الميزان يوم القيامة',
    '🌙 اقرأ آية الكرسي قبل نومك — فهي حفظٌ من الله حتى الصباح',
    '🌅 أذكار الصباح درعٌ يحميك طوال يومك — احرص عليها كل صباح',
    '🌆 أذكار المساء سياجٌ من كل أذى — لا تُفرّط فيها كل مساء',
    '💛 صلِّ على النبي ﷺ الآن — من صلى عليه مرةً صلى الله عليه عشرًا',
    '📿 "سبحان الله وبحمده" مئة مرة — تحطّ الخطايا وإن كانت كزبد البحر',
    '❤️ برّ والديك اليوم — ولو بكلمة طيبة أو اتصال يُدخل السرور على قلبيهما',
    '🕌 الجمعة يومٌ مبارك — اقرأ سورة الكهف تُنِر لك ما بين الجمعتين',
    '🌟 تصدّق ولو بالقليل — فالصدقة تدفع البلاء وتُطفئ غضب الرب',
    '🤍 سامح من أخطأ في حقك — والعفو عند الله أعظم أجرًا',
    '☀️ ابدأ يومك بـ "بسم الله" — تُبارَك في وقتك وعملك',
    '🌿 سبحان الله والحمد لله ولا إله إلا الله والله أكبر — خيرٌ مما طلعت عليه الشمس',
    '📚 خصّص دقائق كل يوم لقراءة شيء من السيرة النبوية — يُحيي قلبك',
    '🙏 إن ضاق صدرك فتوضأ وصلِّ ركعتين — فإن في الصلاة شفاء لما في الصدور',
    '💎 قل الآن: "حسبي الله لا إله إلا هو عليه توكلت" سبعًا — كفاك الله همّك',
    '🌸 احفظ لسانك — فالكلمة الطيبة ترفعك والكلمة السيئة قد تهدمك',
    '⭐ اجعل لك وردًا ثابتًا من الاستغفار — فإن الاستغفار يجلب الرزق والبركة',
    '🕊️ ادعُ لأخٍ بظهر الغيب — فالملَك يُؤمّن على دعائك ويقول "ولك مثله"',
    '🌙 لا تنم قبل أن تُغفر ذنبك — قل: "سبحانك اللهم وبحمدك، أستغفرك وأتوب إليك"',
    '💪 إياك والتسويف — اليوم الذي يمرّ لن يعود، والعمل الصالح لا يُؤجَّل',
    '🌺 أدخل السرور على مسلم — فإن الله في عون العبد ما كان العبد في عون أخيه',
    '✨ بعد الفجر قل: "اللهم إني أسألك علمًا نافعًا ورزقًا طيبًا وعملًا متقبلًا"',
    '🔔 لا تنسَ ذكر الله بين أشغالك — فإن ذكر الله طمأنينة للقلوب',
    '📝 ضع هدفًا إيمانيًا واحدًا لهذا الأسبوع وداوم عليه — فأحب الأعمال إلى الله أدومها',
  ];

  const WISDOMS = [
    '﴿وَمَن يَتَّقِ اللَّهَ يَجْعَل لَّهُ مَخْرَجًا وَيَرْزُقْهُ مِنْ حَيْثُ لَا يَحْتَسِبُ﴾ — سورة الطلاق',
    '﴿إِنَّ مَعَ الْعُسْرِ يُسْرًا﴾ — كرّرها الله مرتين في سورة الشرح لأنها حقيقة مؤكدة',
    '﴿وَاللَّهُ يُحِبُّ الصَّابِرِينَ﴾ — سورة آل عمران',
    '﴿وَأَن تَعْفُوا أَقْرَبُ لِلتَّقْوَى﴾ — سورة البقرة',
    '﴿وَعَسَى أَن تَكْرَهُوا شَيْئًا وَهُوَ خَيْرٌ لَّكُمْ﴾ — سورة البقرة',
    '﴿أَلَا بِذِكْرِ اللَّهِ تَطْمَئِنُّ الْقُلُوبُ﴾ — سورة الرعد',
    '﴿إِنَّ اللَّهَ مَعَ الصَّابِرِينَ﴾ — سورة البقرة',
    '﴿وَمَن يَتَوَكَّلْ عَلَى اللَّهِ فَهُوَ حَسْبُهُ﴾ — سورة الطلاق',
    '﴿فَإِنَّ مَعَ الْعُسْرِ يُسْرًا • إِنَّ مَعَ الْعُسْرِ يُسْرًا﴾ — لن يغلب عسرٌ واحد يُسرين',
    '﴿وَإِذَا سَأَلَكَ عِبَادِي عَنِّي فَإِنِّي قَرِيبٌ أُجِيبُ دَعْوَةَ الدَّاعِ إِذَا دَعَانِ﴾',
    'قال ابن القيم رحمه الله: "القلب في سفر دائم إلى الله، ولا يصلحه إلا الإقبال على الله"',
    'قال ابن القيم رحمه الله: "الصبر على المعصية أيسر من الصبر على عذاب الله"',
    'قال الحسن البصري رحمه الله: "لا تكره شيئًا نزل بك، فلعل في مكروهك خيرًا عظيمًا"',
    'قال الإمام الشافعي رحمه الله: "إذا خفت على عملك العُجب فاذكر رضا من تطلب وفي أي نعيم تُرغّب"',
    'قال ابن تيمية رحمه الله: "في الدنيا جنة من لم يدخلها لم يدخل جنة الآخرة" — وجنته ذكر الله',
    'قال عمر بن الخطاب رضي الله عنه: "حاسبوا أنفسكم قبل أن تُحاسَبوا"',
    'قال علي بن أبي طالب رضي الله عنه: "قيمة كل امرئ ما يُحسنه"',
    'قال الفضيل بن عياض رحمه الله: "اترك الذنب لله لا للناس، فذلك تورّع حقيقي"',
    'قال ابن القيم رحمه الله: "أعظم الناس مصيبةً من أُصيب بدينه"',
    'من أصلح ما بينه وبين الله أصلح الله ما بينه وبين الناس',
    'من أكثر من الاستغفار جعل الله له من كل هم فرجًا ومن كل ضيق مخرجًا ورزقه من حيث لا يحتسب',
    'من تواضع لله رفعه الله — ومن تكبّر وضعه الله',
    'من راقب الله في السر رعاه الله في العلن',
    'من عفا عمّن ظلمه أعزّه الله بين خلقه',
    'من أكثر الصلاة على النبي ﷺ كفاه الله همّه وكفّر عنه ذنبه',
    'من أطاع الله أطاعه كلّ شيء، ومن عصى الله أتعبه كل شيء',
    'من داوم على "لا حول ولا قوة إلا بالله" فُتحت له أبواب السماء',
    'لا تستصغر ذنبًا — فإن الله لا تخفى عليه خافية',
    'لا تستصغر حسنةً — فإن الله شاكرٌ يُضاعف الحسنات',
    'التوبة الصادقة تمحو ما قبلها كأنها لم تكن',
    'الدنيا لحظة، فاجعلها في طاعة الله',
    'من أحبّ لقاء الله أحبّ الله لقاءه',
    'قال السلف: "كن للآخرة أشدّ اجتهادًا منك للدنيا، فإن الدنيا تأتيك وأنت عنها غافل"',
    'قال بعض الحكماء: "الوقت سيف، إن لم تقطعه قطعك"',
    'من أقبل على الله أقبل الله بقلوب العباد عليه',
    'من جاهد نفسه أعانه الله على هواه',
    'من ذكر الله في السراء ذكره الله في الضراء',
    'أشد الناس بلاءً الأنبياء ثم الأمثل فالأمثل — فالبلاء دليل المحبة',
    'الدنيا دار ممر والآخرة دار مقر، فخذوا من ممركم لمقركم',
  ];





  // تغيير الإشعار تلقائياً كل 10 ثواني
// تحميل الإشعارات من localStorage
  useEffect(() => {
    const savedNotifications = localStorage.getItem('islamicNotifications');
    if (savedNotifications) {
      setNotifications(JSON.parse(savedNotifications));
     
          } else {
      // إشعارات افتراضية مبنية على القوائم الكبيرة
      const defaultNotifications = [
        ...HADITHS.map((text, idx) => ({
          id: idx + 1,
          text,
          type: 'hadith',
        })),
        ...ADHKAR.map((text, idx) => ({
          id: 100 + idx + 1,
          text,
          type: 'dhikr',
        })),
        ...SALAWAT.map((text, idx) => ({
          id: 200 + idx + 1,
          text,
          type: 'salawat',
        })),
        ...REMINDERS.map((text, idx) => ({
          id: 300 + idx + 1,
          text,
          type: 'reminder',
        })),
        ...WISDOMS.map((text, idx) => ({
          id: 400 + idx + 1,
          text,
          type: 'wisdom',
        })),
      ];

      setNotifications(defaultNotifications);
      localStorage.setItem('islamicNotifications', JSON.stringify(defaultNotifications));
    }

      

    // استرجاع آخر إشعار تم عرضه
    const lastNotificationIndex = parseInt(localStorage.getItem('lastNotificationIndex') || '0');
    setCurrentNotification(lastNotificationIndex);
  }, []);

  // حفظ آخر إشعار عند التغيير
  useEffect(() => {
    if (notifications.length > 0) {
      localStorage.setItem('lastNotificationIndex', currentNotification.toString());
    }
  }, [currentNotification, notifications.length]);

  // تغيير الإشعار تلقائياً كل 10 ثواني
  useEffect(() => {
    if (notifications.length > 0) {
      const interval = setInterval(() => {
        setCurrentNotification((prev) => {
          const nextIndex = (prev + 1) % notifications.length;
          localStorage.setItem('lastNotificationIndex', nextIndex.toString());
          return nextIndex;
        });
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [notifications.length]);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    
    if (userData) {
      const user = JSON.parse(userData);
      try {
        setUserPermissions(JSON.parse(user.Permissions || '{}'));
      } catch (error) {
        console.error('خطأ في تحليل الصلاحيات:', error);
        setUserPermissions({});
      }
      setFullName(user.FullName || localStorage.getItem('fullName') || '');
    }
  }, []);

  const toggleTheme = () => {
    setDark(!isDark);
  };

  const hasPermission = (section, item) => {
    if (section === 'البيانات' && item === 'قوائم العمل') {
      const dataPerms = userPermissions?.['البيانات'] || {};
      if (Object.prototype.hasOwnProperty.call(dataPerms, 'قوائم العمل')) {
        return dataPerms['قوائم العمل'] === true;
      }
      // توافق للمستخدمين القدامى: لا نخفي الميزة الجديدة قبل إعادة حفظ الصلاحيات.
      return dataPerms['الاختبارات'] === true || userPermissions?.['الجوازات']?.['الجوازات'] === true;
    }
    return userPermissions[section]?.[item] === true;
  };

  const menuSections = [
    {
      id: 1,
      title: "البيانات",
      icon: <Database className="w-6 h-6" />,
      gradient: "from-[#1b3163] via-[#0f1d3d] to-[#0a142b]",
      iconBg: "bg-gold-50 ring-1 ring-gold-200",
      iconColor: "text-gold-700",
      items: [
        { name: "الشركات", icon: <Building2 className="w-5 h-5" />, path: "/companies", color: "blue" },
        { name: "المناديب", icon: <User className="w-5 h-5" />, path: "/delegates", color: "blue" },
        { name: "المهن", icon: <Briefcase className="w-5 h-5" />, path: "/professions", color: "blue" },
        { name: "الاختبارات", icon: <FileCheck className="w-5 h-5" />, path: "/tests", color: "blue" },
        { name: "قوائم العمل", icon: <ListTodo className="w-5 h-5" />, path: "/work-lists", color: "blue" }
      ]
    },
    {
      id: 2,
      title: "الجوازات",
      icon: <FileText className="w-6 h-6" />,
      gradient: "from-[#1b3163] via-[#0f1d3d] to-[#0a142b]",
      iconBg: "bg-gold-50 ring-1 ring-gold-200",
      iconColor: "text-gold-700",
      items: [
        { name: "الجوازات", icon: <FileText className="w-5 h-5" />, path: "/passports", color: "emerald" },
        { name: "الاختيار والتجهيزات", icon: <CheckCircle className="w-5 h-5" />, path: "/selection-preparation", color: "emerald" },
        { name: "الكشوفات", icon: <FileSpreadsheet className="w-5 h-5" />, path: "/reports", color: "emerald" }
      ]
    },
    {
      id: 3,
      title: "التأشيرات",
      icon: <Stamp className="w-6 h-6" />,
      gradient: "from-[#1b3163] via-[#0f1d3d] to-[#0a142b]",
      iconBg: "bg-gold-50 ring-1 ring-gold-200",
      iconColor: "text-gold-700",
      items: [
        { name: "المتابعة الدورية", icon: <Clock className="w-5 h-5" />, path: "/periodic-follow-up", color: "indigo" }
      ]
    },
    {
      id: 4,
      title: "الحسابات",
      icon: <CreditCard className="w-6 h-6" />,
      gradient: "from-[#1b3163] via-[#0f1d3d] to-[#0a142b]",
      iconBg: "bg-gold-50 ring-1 ring-gold-200",
      iconColor: "text-gold-700",
      items: [
        { name: "الخزينة الشاملة", icon: <Wallet className="w-5 h-5" />, path: "/banks", color: "purple" },
        { name: "إيرادات ومصروفات الشركة", icon: <DollarSign className="w-5 h-5" />, path: "/company-transactions", color: "purple" },
        { name: "حسابات العملاء", icon: <Users className="w-5 h-5" />, path: "/client-accounts", color: "purple" },
        { name: "حسابات المناديب", icon: <User className="w-5 h-5" />, path: "/delegate-accounts", color: "purple" },
        { name: "حسابات الموظفين", icon: <UserCheck className="w-5 h-5" />, path: "/employee-accounts", color: "purple" },
        { name: "التقارير", icon: <BarChart3 className="w-5 h-5" />, path: "/financial-reports", color: "purple" }
      ]
    },
    {
      id: 6,
      title: "المستخدمين",
      icon: <Users className="w-6 h-6" />,
      gradient: "from-[#1b3163] via-[#0f1d3d] to-[#0a142b]",
      iconBg: "bg-gold-50 ring-1 ring-gold-200",
      iconColor: "text-gold-700",
      items: [
        { name: "المستخدمين", icon: <Users className="w-5 h-5" />, path: "/users", color: "red" }
      ]
    },
    {
      id: 7,
      title: "إدارة قاعدة البيانات",
      icon: <Database className="w-6 h-6" />,
      gradient: "from-[#1b3163] via-[#0f1d3d] to-[#0a142b]",
      iconBg: "bg-gold-50 ring-1 ring-gold-200",
      iconColor: "text-gold-700",
      items: [
        { 
          name: "إدارة البيانات",
          icon: <Upload className="w-5 h-5" />,
          path: "/data-management",
          description: "استيراد وحذف البيانات من جميع الصفحات",
          color: "amber"
        },
        { 
          name: "النسخ الاحتياطي وإدارة قاعدة البيانات",
          icon: <Save className="w-5 h-5" />,
          path: "/db-backup",
          description: "إنشاء نسخة احتياطية وحذف البيانات",
          color: "amber",
          warning: true
        }
      ]
    }
  ];

  const handleNavigate = (path, warning = false) => {
    if (warning) {
      if (window.confirm('هذا الإجراء خطير. هل أنت متأكد من المتابعة؟')) {
        navigate(path);
      }
    } else {
      navigate(path);
    }
  };

  const normalizeMobileItem = (item) => {
    if (item.name === 'الكشوفات') {
      return {
        ...item,
        displayName: 'كشف الجوازات',
        path: '/passport-report'
      };
    }
    return item;
  };

  const permittedMobileSections = menuSections
    .map(section => ({
      ...section,
      items: section.items
        .filter(item => hasPermission(section.title, item.name))
        .map(normalizeMobileItem)
    }))
    .filter(section => section.items.length > 0);

  const findMobileItem = (itemName) => {
    for (const section of menuSections) {
      const item = section.items.find(i => i.name === itemName && hasPermission(section.title, i.name));
      if (item) return { ...normalizeMobileItem(item), sectionTitle: section.title };
    }
    return null;
  };

  const displayUserName = (() => {
    if (fullName && fullName.trim()) return fullName.trim();
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      return (
        user.FullName ||
        user.fullName ||
        user.Name ||
        user.name ||
        user.Username ||
        user.username ||
        localStorage.getItem('fullName') ||
        'مستخدم النظام'
      );
    } catch (error) {
      return localStorage.getItem('fullName') || 'مستخدم النظام';
    }
  })();

  const getMobileAction = (itemName, displayName = itemName) => {
    const item = findMobileItem(itemName);
    return item ? { ...item, displayName } : null;
  };

  const mobileQuickActions = [
    getMobileAction('الجوازات'),
    getMobileAction('المتابعة الدورية'),
    getMobileAction('الكشوفات', 'كشف الجوازات'),
    getMobileAction('الخزينة الشاملة', 'الخزينة الرئيسية'),
    getMobileAction('إيرادات ومصروفات الشركة'),
    getMobileAction('حسابات العملاء')
  ].filter(Boolean);

  const mobileSearchResults = mobileSearch.trim()
    ? permittedMobileSections.flatMap(section =>
        section.items
          .filter(item =>
            item.name.toLowerCase().includes(mobileSearch.trim().toLowerCase()) ||
            section.title.toLowerCase().includes(mobileSearch.trim().toLowerCase())
          )
          .map(item => ({ ...item, sectionTitle: section.title }))
      )
    : [];

  const handleLogout = () => {
    localStorage.removeItem('user');
    onLogout();
  };

  // إدارة الإشعارات
  const saveNotifications = (updatedNotifications) => {
    setNotifications(updatedNotifications);
    localStorage.setItem('islamicNotifications', JSON.stringify(updatedNotifications));
  };

  const handleAddNotification = () => {
    if (newNotification.text.trim()) {
      const notification = {
        id: Date.now(),
        text: newNotification.text,
        type: newNotification.type
      };
      const updated = [...notifications, notification];
      saveNotifications(updated);
      setNewNotification({ text: '', type: 'hadith' });
      setIsEditing(false);
    }
  };

  const handleEditNotification = (notification) => {
    setEditingId(notification.id);
    setNewNotification({ text: notification.text, type: notification.type });
    setIsEditing(true);
  };

  const handleUpdateNotification = () => {
    if (newNotification.text.trim()) {
      const updated = notifications.map(n => 
        n.id === editingId 
          ? { ...n, text: newNotification.text, type: newNotification.type }
          : n
      );
      saveNotifications(updated);
      setNewNotification({ text: '', type: 'hadith' });
      setIsEditing(false);
      setEditingId(null);
    }
  };

  const handleDeleteNotification = (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الإشعار؟')) {
      const updated = notifications.filter(n => n.id !== id);
      saveNotifications(updated);
      setCurrentNotification(0);
    }
  };

  // 🔹 تقسيم النص إلى أجزاء: نص عادي + إيموجي — لمنع تأثير WebkitTextFillColor على الإيموجي
  const renderNameWithEmoji = (text) => {
    if (!text) return 'بك';
    const parts = text.split(/(\p{Extended_Pictographic}|\p{Emoji_Presentation})/gu);
    return parts.map((part, i) => {
      const isEmoji = /^\p{Extended_Pictographic}$|^\p{Emoji_Presentation}$/u.test(part);
      if (isEmoji) {
        return (
          <span key={i} style={{
            WebkitTextFillColor: 'initial',
            background: 'none',
            WebkitBackgroundClip: 'unset',
            backgroundClip: 'unset',
            display: 'inline-block',
          }}>
            {part}
          </span>
        );
      }
      return part || null;
    });
  };

  const getNotificationIcon = (type) => {
    switch(type) {
      case 'hadith': return '📖';
      case 'dhikr': return '🤲';
      case 'salawat': return '☪️';
      case 'reminder': return '⏰';
      default: return '📿';
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDark 
        ? 'bg-[#0a1222]' 
        : 'bg-[#f4f6fa]'
    }`}>

      <style>{`
        @media (max-width: 767px) {
          .dashboard-desktop-content { display: none !important; }
          .dashboard-mobile-app { display: block !important; }
          .dashboard-mobile-app * { box-sizing: border-box; }
          .dashboard-mobile-no-scrollbar::-webkit-scrollbar { display: none; }
          .dashboard-mobile-no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

        }
        @media (min-width: 768px) {
          .dashboard-mobile-app { display: none !important; }
        }
      `}</style>

      <div className="dashboard-mobile-app min-h-screen pb-28 bg-[#f4f6fa] dark:bg-[#0a1222] text-slate-900" dir="rtl">
        <div className="px-4 pt-4 space-y-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <img
                src={nesrLogo}
                alt={BRAND.arabicName}
                className="w-12 h-12 rounded-2xl bg-white p-1 shadow-sm object-contain flex-shrink-0"
              />
              <div className="min-w-0">
                <h1 className="text-base font-black text-slate-900 truncate">نسر الخليج</h1>
                <p className="text-xs text-slate-500 truncate">مرحبًا، {displayUserName}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={handleLogout}
                className="w-11 h-11 rounded-2xl bg-white shadow-sm flex items-center justify-center text-red-600"
                aria-label="خروج"
              >
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="relative">
            <Search className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
            <input
              value={mobileSearch}
              onChange={(e) => setMobileSearch(e.target.value)}
              placeholder="ابحث عن صفحة أو تقرير..."
              className="w-full h-14 rounded-3xl bg-white border border-slate-200 shadow-sm pr-12 pl-4 text-sm outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>

          {mobileSearch.trim() && (
            <div className="bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
                <span className="font-bold text-slate-900">نتائج البحث</span>
                <button onClick={() => setMobileSearch('')} className="text-slate-400 p-1">
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="p-2 space-y-2 max-h-80 overflow-y-auto dashboard-mobile-no-scrollbar">
                {mobileSearchResults.length > 0 ? mobileSearchResults.map((item, index) => (
                  <button
                    key={`${item.name}-${index}`}
                    onClick={() => handleNavigate(item.path, item.warning)}
                    className="w-full rounded-2xl p-3 bg-slate-50 border border-slate-100 flex items-center justify-between text-right"
                  >
                    <span className="flex items-center gap-3 min-w-0">
                      <span className="w-11 h-11 rounded-2xl bg-white flex items-center justify-center text-blue-600 shadow-sm flex-shrink-0">{item.icon}</span>
                      <span className="min-w-0">
                        <span className="block font-bold text-sm text-slate-900 truncate">{item.displayName || item.name}</span>
                        <span className="block text-xs text-slate-500 truncate">{item.sectionTitle}</span>
                      </span>
                    </span>
                    <ChevronLeft className="w-5 h-5 text-slate-400 flex-shrink-0" />
                  </button>
                )) : (
                  <div className="py-8 text-center text-sm text-slate-500">لا توجد نتائج مطابقة</div>
                )}
              </div>
            </div>
          )}

          <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-l from-blue-50 to-white border border-blue-100 shadow-sm p-5">
            <div className="absolute -left-8 -bottom-8 w-32 h-32 rounded-full bg-blue-100/70"></div>
            <div className="relative flex items-center justify-between gap-3">
              <div>
                <p className="text-xs font-semibold text-blue-600 mb-1">لوحة التحكم</p>
                <h2 className="text-xl font-black text-slate-900 leading-8">أهلًا {displayUserName} 👋</h2>
                <p className="text-sm text-slate-500 leading-6 mt-1">إدارة متكاملة لعمليات إلحاق العمالة والسفر</p>
              </div>
              <div className="w-20 h-20 rounded-full bg-[#fff] ring-2 ring-gold-300 flex items-center justify-center shadow-lg flex-shrink-0">
                <img src={nesrLogo} alt="نسر الخليج" className="w-16 h-16 object-contain" />
              </div>
            </div>
          </div>

          {mobileQuickActions.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-black text-slate-900">اختصارات سريعة</h3>
                <span className="text-amber-500 text-xl">⚡</span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {mobileQuickActions.map((item, index) => (
                  <button
                    key={`${item.name}-${index}`}
                    onClick={() => handleNavigate(item.path, item.warning)}
                    className="min-h-[104px] rounded-[24px] bg-white border border-slate-100 shadow-sm p-4 text-right flex flex-col justify-between active:scale-[0.98] transition-transform"
                  >
                    <span className={`w-12 h-12 rounded-2xl ${item.color === 'purple' ? 'bg-purple-50 text-purple-600' : item.color === 'emerald' ? 'bg-emerald-50 text-emerald-600' : item.color === 'indigo' ? 'bg-indigo-50 text-indigo-600' : 'bg-blue-50 text-blue-600'} flex items-center justify-center`}>
                      {item.icon}
                    </span>
                    <span className="font-extrabold text-sm text-slate-900 leading-6">{item.displayName || item.name}</span>
                  </button>
                ))}
              </div>
            </div>
          )}



          <div>
            <h3 className="text-lg font-black text-slate-900 mb-3">الأقسام الرئيسية</h3>
            <div className="space-y-3">
              {permittedMobileSections.map((section) => {
                const isOpen = openMobileSection === section.id;
                return (
                  <div key={section.id} className="bg-white rounded-[24px] border border-slate-100 shadow-sm overflow-hidden">
                    <button
                      onClick={() => setOpenMobileSection(isOpen ? null : section.id)}
                      className="w-full p-4 flex items-center justify-between gap-3 text-right"
                    >
                      <span className="flex items-center gap-3 min-w-0">
                        <span className={`w-12 h-12 rounded-2xl ${section.iconBg} ${section.iconColor} flex items-center justify-center flex-shrink-0`}>
                          {section.icon}
                        </span>
                        <span className="min-w-0">
                          <span className="block font-black text-slate-900">{section.title}</span>
                          <span className="block text-xs text-slate-500 mt-1 truncate">{section.items.map(item => item.displayName || item.name).join('، ')}</span>
                        </span>
                      </span>
                      <ChevronLeft className={`w-5 h-5 text-slate-400 transition-transform ${isOpen ? '-rotate-90' : ''}`} />
                    </button>

                    {isOpen && (
                      <div className="px-4 pb-4 grid grid-cols-1 gap-2">
                        {section.items.map((item, index) => (
                          <button
                            key={`${section.id}-${index}`}
                            onClick={() => handleNavigate(item.path, item.warning)}
                            className="w-full rounded-2xl p-3 bg-slate-50 border border-slate-100 flex items-center justify-between text-right"
                          >
                            <span className="flex items-center gap-3 min-w-0">
                              <span className="w-10 h-10 rounded-xl bg-white flex items-center justify-center text-slate-700 shadow-sm flex-shrink-0">{item.icon}</span>
                              <span className="min-w-0">
                                <span className="block font-bold text-sm text-slate-900 truncate">{item.displayName || item.name}</span>
                                {item.description && <span className="block text-xs text-slate-500 truncate mt-1">{item.description}</span>}
                              </span>
                            </span>
                            {item.warning ? <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" /> : <ChevronLeft className="w-5 h-5 text-slate-400 flex-shrink-0" />}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>



        </div>
      </div>

      <div className="dashboard-desktop-content">
      {/* Header */}
      <div className={`sticky top-0 z-50 backdrop-blur-lg border-b transition-colors duration-300 ${
        isDark 
          ? 'bg-white/95 border-gray-200' 
          : 'bg-white/95 border-gray-200 shadow-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4 space-x-reverse">
              <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                className={`lg:hidden p-2 rounded-lg transition-colors ${
                  isDark 
                    ? 'hover:bg-gray-800 text-gray-300' 
                    : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                {isSidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
              
                     {/* Header logo - Masar Smart Systems */}
              <div className="flex items-center gap-3">
                {/* Masar Logo */}
                <div className="relative flex items-center justify-center flex-shrink-0">
                  {/* Subtle glow ring behind logo */}

                  <img
                  src={nesrLogo}
                    alt={BRAND.arabicName}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: 'contain',
                      borderRadius: '50%',
                      background: '#fff',
                      padding: 3,
                      boxShadow: '0 0 0 2px rgba(212,171,76,0.55), 0 4px 12px -4px rgba(15,29,61,0.35)',
                      position: 'relative',
                      zIndex: 1,
                    }}
                  />
                </div>

                {/* Brand Text */}
                <div>
                  <h1 className="text-base sm:text-xl font-black leading-tight text-navy-900">
                    {BRAND.arabicName}
                  </h1>

                  <p className="text-xs font-semibold text-gold-700">
                    {BRAND.englishName}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-3 space-x-reverse">
              {/* Theme Toggle */}
              <button
                onClick={toggleTheme}
                className={`p-2.5 rounded-xl transition-all duration-300 ${
                  isDark 
                    ? 'bg-gray-800 hover:bg-gray-700 text-gold-300' 
                    : 'bg-gray-100 hover:bg-gray-200 text-navy-800'
                } shadow-sm hover:shadow-md`}
              >
                {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
              </button>

              {/* Logout Button */}
              <button
                onClick={handleLogout}
                className={`inline-flex items-center px-4 py-2.5 rounded-xl shadow-sm text-sm font-medium transition-all duration-300 ${
                  isDark
                    ? 'bg-red-600 hover:bg-red-700 text-white shadow-red-900/30'
                    : 'bg-red-600 hover:bg-red-700 text-white shadow-red-600/20'
                } hover:shadow-lg`}
              >
                <LogOut className="ml-2 h-5 w-5" />
                <span className="hidden sm:inline">خروج</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Welcome Banner */}
        <div className={`mb-6 rounded-2xl shadow-xl relative overflow-hidden ${
          isDark 
            ? 'bg-gradient-to-l from-[#13254d] via-[#0f1d3d] to-[#0a142b] ring-1 ring-white/5' 
            : 'bg-gradient-to-l from-[#1b3163] via-[#0f1d3d] to-[#0a142b]'
        }`}>
          {/* Grid Pattern from Login */}
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px)',
            backgroundSize: '22px 22px',
          }}></div>
          {/* Glow */}
          <div className="absolute inset-0" style={{
            background: 'radial-gradient(ellipse 50% 90% at 15% 50%, rgba(212,171,76,0.16) 0%, transparent 70%)'
          }}></div>

          <div className="relative z-10 flex flex-col lg:flex-row items-stretch gap-0">
            {/* Welcome content */}
            <div className="flex-1 flex items-center justify-between gap-6 p-6">
              {/* Welcome text */}
              <div className="flex-1">
                {/* Arabic decorative welcome */}
                <div className="mb-2">
                  <p className="text-white/50 text-xs tracking-widest uppercase mb-1" style={{ letterSpacing: '4px', fontFamily: 'Tajawal, sans-serif' }}>
                    ✦ مرحباً بك في النظام ✦
                  </p>
                  <h2 style={{
                    fontFamily: 'Tajawal, Cairo, sans-serif',
                    fontSize: '1.7rem',
                    fontWeight: 800,
                    lineHeight: 1.3,
                    background: 'linear-gradient(135deg, #ffffff 0%, #eef2f9 60%, #d9e1f0 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    textShadow: 'none',
                  }}>
                    أهلاً وسهلاً،{' '}
                    <span style={{
                      background: 'linear-gradient(135deg, #f0d896 0%, #d4ab4c 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                    }}>
                      {renderNameWithEmoji(fullName)}
                    </span>
                    {' '}<span style={{ WebkitTextFillColor: 'initial', background: 'none', WebkitBackgroundClip: 'unset', backgroundClip: 'unset' }}>👋</span>
                  </h2>
                </div>
                <p className="text-white/60 text-sm">اختر من القوائم التالية للبدء في العمل</p>
              </div>

              {/* Islamic Notification Section */}
              {notifications.length > 0 && (
                <div className={`flex-1 relative p-4 rounded-xl backdrop-blur-md transition-all duration-500 ${
                  isDark 
                    ? 'bg-[#fff]/5 border border-[#fff]/10' 
                    : 'bg-[#fff]/10 border border-[#fff]/20'
                }`}>
                  <div className="flex items-start gap-3">
                    <div className="text-3xl animate-pulse">
                      {getNotificationIcon(notifications[currentNotification]?.type)}
                    </div>
                    <div className="flex-1">
                      <p className="text-white text-sm leading-relaxed font-medium">
                        {notifications[currentNotification]?.text}
                      </p>
                    </div>
                  </div>
                  
                  {/* Progress Dots */}
<div className="flex justify-center gap-1.5 mt-3">
  {Array.from({ length: Math.min(5, notifications.length) }).map((_, index) => {
    const dotsCount = Math.min(5, notifications.length);
    const activeDotIndex = Math.floor((currentNotification / notifications.length) * dotsCount);
    const isActive = index === activeDotIndex;

    const targetIndex = Math.min(
      Math.floor((index / dotsCount) * notifications.length),
      notifications.length - 1
    );

    return (
      <button
        key={index}
        onClick={() => setCurrentNotification(targetIndex)}
        className={`h-1.5 rounded-full transition-all duration-300 ${
          isActive
            ? 'w-6 bg-[#d4ab4c]'
            : 'w-1.5 bg-[#fff]/40 hover:bg-[#fff]/60'
        }`}
      />
    );
  })}
</div>


                  {/* Hidden Settings Button - Click 5 times to open */}
                  <button
                    onClick={() => {
                      const clicks = parseInt(localStorage.getItem('notifClicks') || '0') + 1;
                      localStorage.setItem('notifClicks', clicks.toString());
                      if (clicks >= 5) {
                        setShowNotificationManager(true);
                        localStorage.setItem('notifClicks', '0');
                      }
                    }}
                    className="absolute top-2 left-2 w-2 h-2 opacity-0 hover:opacity-100"
                  />
                </div>
              )}

                  {/* Banner Logo */}
              <div className="hidden lg:flex flex-col items-center justify-center px-6 gap-2">
                <div className="relative">
                  {/* Spinning ring behind logo */}
                  <div
                    className="absolute rounded-full border border-[#d4ab4c]/50 animate-spin"
                    style={{ inset: '-8px', animationDuration: '15s' }}
                  ></div>
                  <div
                    className="absolute rounded-full border border-dashed border-white/15 animate-spin"
                    style={{
                      inset: '-16px',
                      animationDuration: '10s',
                      animationDirection: 'reverse',
                    }}
                  ></div>

                  <img
                    src={nesrLogo}
                    alt="شعار نسر الخليج"
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: 'contain',
                      borderRadius: '50%',
                      border: '2px solid rgba(212,171,76,0.6)',
                      background: '#fff',
                      padding: 4,
                      filter: 'drop-shadow(0 6px 18px rgba(0,0,0,0.35))',
                      position: 'relative',
                      zIndex: 1,
                    }}
                  />
                </div>

                <p
                  className="text-white/60 text-xs font-medium mt-1"
                  style={{
                    fontFamily: 'Tajawal, sans-serif',
                    letterSpacing: '1px',
                  }}
                >
                  {BRAND.systemName}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {menuSections.map((section) => {
            const hasAnySectionPermission = section.items.some(item => 
              hasPermission(section.title, item.name)
            );

            if (!hasAnySectionPermission) {
              return null;
            }

            return (
            <div
              key={section.id}
              className={`group rounded-3xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 ${
                isDark 
                  ? 'bg-white border border-gray-200 hover:border-gold-400/60' 
                  : 'bg-white border border-gray-200 hover:border-gold-300'
              }`}
            >
              {/* Section Header */}
              <div className={`bg-gradient-to-r ${section.gradient} p-6 relative overflow-hidden`}>
                {/* Animated Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                  <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent"></div>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>
                </div>
                
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center space-x-4 space-x-reverse">
                    <div className="p-4 bg-gradient-to-br from-[#e8cb7d] to-[#b98a2c] text-[#0f1d3d] rounded-2xl shadow-lg transform transition-transform duration-300 group-hover:scale-110">
                      {section.icon}
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-white mb-1">{section.title}</h2>
                      <div className="flex items-center space-x-2 space-x-reverse">
                        <div className="w-2 h-2 rounded-full bg-[#d4ab4c]"></div>
                        <span className="text-white/80 text-sm">{section.items.filter(item => hasPermission(section.title, item.name)).length} عناصر</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section Items */}
              <div className="p-5 space-y-2">
                {section.items.map((item, index) => {
                  if (!hasPermission(section.title, item.name)) {
                    return null;
                  }

                  return (
                    <button
                    key={index}
                    onClick={() => handleNavigate(item.path, item.warning)}
                    className={`w-full group relative overflow-hidden rounded-xl p-4 transition-all duration-300 ${
                      'hover:bg-gold-50/60 bg-white'
                    } border ${
                      'border-gray-200 hover:border-gold-300'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3 space-x-reverse">
                        <div className={`p-2.5 rounded-xl ${section.iconBg} ${section.iconColor} transition-transform duration-300 group-hover:scale-110`}>
                          {item.icon}
                        </div>
                        <div className="text-right">
                          <div className="text-sm font-bold text-gray-900">
                            {item.name}
                          </div>
                          {item.description && (
                            <div className={`text-xs mt-1 ${
                              isDark ? 'text-gray-400' : 'text-gray-500'
                            }`}>
                              {item.description}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 space-x-reverse">
                        {item.warning && (
                          <AlertCircle className="w-5 h-5 text-red-500" />
                        )}
                        <ChevronLeft className={`w-5 h-5 transition-transform duration-300 group-hover:-translate-x-1 ${
                          isDark ? 'text-gray-400' : 'text-gray-400'
                        }`} />
                      </div>
                    </div>
                  </button>
                  );
                })}
              </div>
            </div>
            );
          })}
        </div>
      </div>

      {/* Footer */}
      <div className={`mt-8 py-4 border-t ${
        isDark ? 'border-gray-800' : 'border-gray-200'
      }`}>
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <p className={`text-center text-xs ${
            isDark ? 'text-gray-400' : 'text-gray-500'
          }`}>
        {BRAND.footerText}
          </p>
        </div>
      </div>

      {/* Notification Manager Modal */}
      {showNotificationManager && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
          <div className={`w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl ${
            isDark ? 'bg-gray-800' : 'bg-white'
          }`}>
            {/* Header */}
            <div className={`sticky top-0 p-6 border-b ${
              isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
            }`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`p-3 rounded-xl ${
                    isDark ? 'bg-emerald-900/30' : 'bg-emerald-100'
                  }`}>
                    <BookOpen className={`w-6 h-6 ${
                      isDark ? 'text-emerald-400' : 'text-emerald-600'
                    }`} />
                  </div>
                  <div>
                    <h3 className={`text-xl font-bold ${
                      isDark ? 'text-white' : 'text-gray-900'
                    }`}>
                      إدارة الإشعارات الإسلامية
                    </h3>
                    <p className={`text-sm ${
                      isDark ? 'text-gray-400' : 'text-gray-600'
                    }`}>
                      إضافة وتعديل الأحاديث والأذكار
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setShowNotificationManager(false);
                    setIsEditing(false);
                    setEditingId(null);
                    setNewNotification({ text: '', type: 'hadith' });
                  }}
                  className={`p-2 rounded-lg transition-colors ${
                    isDark 
                      ? 'hover:bg-gray-700 text-gray-400' 
                      : 'hover:bg-gray-100 text-gray-600'
                  }`}
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6">
              {/* Add/Edit Form */}
              <div className={`p-5 rounded-xl border-2 ${
                isDark 
                  ? 'bg-gray-750 border-gray-700' 
                  : 'bg-gray-50 border-gray-200'
              }`}>
                <h4 className={`text-lg font-semibold mb-4 ${
                  isDark ? 'text-white' : 'text-gray-900'
                }`}>
                  {isEditing ? 'تعديل الإشعار' : 'إضافة إشعار جديد'}
                </h4>
                
                <div className="space-y-4">
                  <div>
                    <label className={`block text-sm font-medium mb-2 ${
                      isDark ? 'text-gray-300' : 'text-gray-700'
                    }`}>
                      نوع الإشعار
                    </label>
                    <select
                      value={newNotification.type}
                      onChange={(e) => setNewNotification({...newNotification, type: e.target.value})}
                      className={`w-full px-4 py-2.5 rounded-lg border-2 transition-colors ${
                        isDark
                          ? 'bg-gray-700 border-gray-600 text-white focus:border-emerald-500'
                          : 'bg-white border-gray-300 text-gray-900 focus:border-emerald-500'
                      } focus:outline-none`}
                    >
                      <option value="hadith">📖 حديث نبوي</option>
                      <option value="dhikr">🤲 ذكر</option>
                      <option value="salawat">☪️ صلاة على النبي</option>
                      <option value="reminder">⏰ تذكير</option>
                      <option value="wisdom">💎 حكمة</option>
                    </select>
                  </div>

                  <div>
                    <label className={`block text-sm font-medium mb-2 ${
                      isDark ? 'text-gray-300' : 'text-gray-700'
                    }`}>
                      النص
                    </label>
                    <textarea
                      value={newNotification.text}
                      onChange={(e) => setNewNotification({...newNotification, text: e.target.value})}
                      placeholder="اكتب الحديث أو الذكر أو التذكير هنا..."
                      rows={4}
                      className={`w-full px-4 py-2.5 rounded-lg border-2 transition-colors resize-none ${
                        isDark
                          ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-emerald-500'
                          : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500 focus:border-emerald-500'
                      } focus:outline-none`}
                    />
                  </div>

                  <div className="flex gap-3">
                    {isEditing ? (
                      <>
                        <button
                          onClick={handleUpdateNotification}
                          className="flex-1 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
                        >
                          <Save className="w-5 h-5" />
                          حفظ التعديلات
                        </button>
                        <button
                          onClick={() => {
                            setIsEditing(false);
                            setEditingId(null);
                            setNewNotification({ text: '', type: 'hadith' });
                          }}
                          className={`px-4 py-2.5 rounded-lg font-medium transition-colors ${
                            isDark
                              ? 'bg-gray-700 hover:bg-gray-600 text-white'
                              : 'bg-gray-200 hover:bg-gray-300 text-gray-900'
                          }`}
                        >
                          إلغاء
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={handleAddNotification}
                        className="w-full px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
                      >
                        <Plus className="w-5 h-5" />
                        إضافة إشعار
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Notifications List */}
              <div>
                <h4 className={`text-lg font-semibold mb-4 ${
                  isDark ? 'text-white' : 'text-gray-900'
                }`}>
                  الإشعارات الحالية ({notifications.length})
                </h4>
                
                <div className="space-y-3">
                  {notifications.map((notification, index) => (
                    <div
                      key={notification.id}
                      className={`p-4 rounded-xl border-2 transition-all ${
                        isDark
                          ? 'bg-gray-750 border-gray-700 hover:border-gray-600'
                          : 'bg-white border-gray-200 hover:border-gray-300'
                      }`}
                    >
                      <div className="flex items-start gap-3">
                        <div className="text-2xl pt-1">
                          {getNotificationIcon(notification.type)}
                        </div>
                        <div className="flex-1">
                          <p className={`text-sm leading-relaxed ${
                            isDark ? 'text-gray-300' : 'text-gray-700'
                          }`}>
                            {notification.text}
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleEditNotification(notification)}
                            className={`p-2 rounded-lg transition-colors ${
                              isDark
                                ? 'hover:bg-blue-900/30 text-blue-400'
                                : 'hover:bg-blue-100 text-blue-600'
                            }`}
                          >
                            <Edit2 className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDeleteNotification(notification.id)}
                            className={`p-2 rounded-lg transition-colors ${
                              isDark
                                ? 'hover:bg-red-900/30 text-red-400'
                                : 'hover:bg-red-100 text-red-600'
                            }`}
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default Dashboard;